"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const short_uuid_1 = __importDefault(require("short-uuid"));
const placesAutocompleteStyles_1 = __importDefault(require("./helpers/placesAutocompleteStyles"));
const ControlRendererContext_1 = __importDefault(require("../../../ControlRendererContext"));
const ErrorApiKeyRenderer_1 = __importDefault(require("../ErrorApiKeyRenderer"));
const getNumberFromUnknown_1 = __importDefault(require("../../../shared/getNumberFromUnknown"));
const valueIsNullOrUndef_1 = __importDefault(require("../../../typeAssertions/valueIsNullOrUndef"));
const valueIsString_1 = __importDefault(require("../../../typeAssertions/valueIsString"));
const getValueByPathFromUnknown_1 = __importDefault(require("../../../shared/getValueByPathFromUnknown"));
const getPlaceTypesFromRawType = (type) => {
    switch (type) {
        case '(regions)':
            return ['country', 'geocode', 'locality'];
        case '(cities)':
            return ['postal_town', 'political', 'neighborhood'];
        case 'geocode':
            return ['geocode'];
        case 'address':
            return ['colloquial_area', 'intersection', 'post_box', 'postal_code', 'postal_code_prefix', 'postal_code_suffix', 'postal_town'];
        case 'establishment':
            return ['establishment'];
        default:
            return [];
    }
};
const autocompleteTypesToFilter = (types) => {
    if ((0, valueIsNullOrUndef_1.default)(types)) {
        return [
            'administrative_area_level_1',
            'administrative_area_level_2',
            'administrative_area_level_3',
            'administrative_area_level_4',
            'administrative_area_level_5',
            'colloquial_area',
            'country',
            'establishment',
            'finance',
            'floor',
            'food',
            'general_contractor',
            'geocode',
            'health',
            'intersection',
            'locality',
            'natural_feature',
            'neighborhood',
            'place_of_worship',
            'political',
            'point_of_interest',
            'post_box',
            'postal_code',
            'postal_code_prefix',
            'postal_code_suffix',
            'postal_town',
            'premise',
            'room',
            'route',
            'street_address',
            'street_number',
            'sublocality',
            'sublocality_level_4',
            'sublocality_level_5',
            'sublocality_level_3',
            'sublocality_level_2',
            'sublocality_level_1',
            'subpremise',
        ];
    }
    if ((0, valueIsString_1.default)(types)) {
        return getPlaceTypesFromRawType(types);
    }
    return types
        .filter(valueIsString_1.default)
        .map(getPlaceTypesFromRawType)
        .reduce((accum, current) => [...accum, ...current], []);
};
const PlacesAutocomplete = ({ control, onChangeText, style, onBlur, onFocus, inputRef, newStyle, onChange, }) => {
    var _a, _b;
    const [autocompleteSessionId, setAutocompleteSessionId,] = (0, react_1.useState)(() => short_uuid_1.default.generate());
    const { Render, functions: { processor }, } = (0, react_1.useContext)(ControlRendererContext_1.default);
    const googleApiKey = (_b = (_a = processor.root.getBuildOrders()) === null || _a === void 0 ? void 0 : _a.googleApis) === null || _b === void 0 ? void 0 : _b.googleApiKey;
    const platform = processor.root.platformOS;
    const [showListPlaces, setShowListPlaces] = (0, react_1.useState)(false);
    const placesAutocompleteStyles = (0, react_1.useMemo)(() => (0, placesAutocompleteStyles_1.default)(style), [style]);
    const nearLocation = (0, react_1.useMemo)(() => {
        var _a, _b;
        try {
            return {
                latitude: (0, getNumberFromUnknown_1.default)((_a = control.nearLocation) === null || _a === void 0 ? void 0 : _a.latitude),
                longitude: (0, getNumberFromUnknown_1.default)((_b = control.nearLocation) === null || _b === void 0 ? void 0 : _b.longitude),
            };
        }
        catch (_c) {
            return undefined;
        }
    }, [control]);
    const locationRadius = (0, react_1.useMemo)(() => {
        var _a;
        try {
            return (0, getNumberFromUnknown_1.default)((_a = control.nearLocation) === null || _a === void 0 ? void 0 : _a.radius);
        }
        catch (_b) {
            return undefined;
        }
    }, [control.nearLocation]);
    const textValue = (0, react_1.useMemo)(() => {
        if ((0, valueIsString_1.default)(control.value)) {
            return control.value;
        }
        const rawDescription = (0, getValueByPathFromUnknown_1.default)(control.value, ['description']);
        if ((0, valueIsString_1.default)(rawDescription)) {
            return rawDescription;
        }
        return undefined;
    }, [control.value]);
    if (platform && !googleApiKey) {
        return react_1.default.createElement(ErrorApiKeyRenderer_1.default, { style: newStyle });
    }
    return (react_1.default.createElement(Render.GooglePlacesAutocomplete, { listViewDisplayed: showListPlaces, inputRef: inputRef, textValue: textValue, onBlur: () => {
            if (onBlur) {
                onBlur();
            }
            setShowListPlaces(false);
        }, onFocus: () => {
            setShowListPlaces(true);
            if (onFocus) {
                onFocus();
            }
        }, onChangeText: (newText) => {
            onChangeText(newText || undefined);
        }, placeholder: control.placeHolder || '', minLength: 2, fetchDetails: true, onPress: (event, details) => {
            const { geometry: { location = {
                lat: undefined,
                lng: undefined,
            }, } = {}, formatted_address: formattedAddress, vicinity, } = details || {};
            setAutocompleteSessionId(short_uuid_1.default.generate());
            const newValue = {
                formattedAddress,
                location: {
                    latitude: location === null || location === void 0 ? void 0 : location.lat,
                    longitude: location === null || location === void 0 ? void 0 : location.lng,
                },
                colony: vicinity,
                description: event.description,
            };
            if (details) {
                newValue.details = details;
            }
            onChange(newValue);
        }, styles: placesAutocompleteStyles, filterReverseGeocodingByTypes: autocompleteTypesToFilter(control.types), query: {
            // available options: https://developers.google.com/places/web-service/autocomplete
            key: `${googleApiKey}`,
            language: 'en',
            components: control.components || undefined,
            location: nearLocation
                ? `${nearLocation.latitude},${nearLocation.longitude}`
                : undefined,
            radius: locationRadius,
            sessiontoken: autocompleteSessionId,
        } }));
};
exports.default = PlacesAutocomplete;
